export default class PaymentTerm {
  type?: string;
  days?: number;

  constructor(type?: string, days?: number) {
    this.type = type;
    this.days = days;
  }
}

export const COMPANY_PAYMENT_TERMS = [
  {
    label: 'Vandaag',
    paymentTerm: new PaymentTerm('after_invoice_date', 0)
  },
  {
    label: 'Vandaag + 14 dagen',
    paymentTerm: new PaymentTerm('after_invoice_date', 14)
  },
  {
    label: 'Vandaag + 30 dagen',
    paymentTerm: new PaymentTerm('after_invoice_date', 30)
  },
  {
    label: 'Einde maand + 30 dagen',
    paymentTerm: new PaymentTerm('end_of_month', 30)
  }
];
